import { render, staticRenderFns } from "./information.vue?vue&type=template&id=1d8bd10b&scoped=true"
import script from "./information.vue?vue&type=script&lang=ts"
export * from "./information.vue?vue&type=script&lang=ts"
import style0 from "./information.vue?vue&type=style&index=0&id=1d8bd10b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8bd10b",
  null
  
)

export default component.exports